/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FeatureImportanceFromJSON, FeatureImportanceToJSON, } from './FeatureImportance.js';
/**
 * Check if a given object implements the MatchingConfiguration interface.
 */
export function instanceOfMatchingConfiguration(value) {
    if (!('workExperienceImportance' in value) || value['workExperienceImportance'] === undefined)
        return false;
    if (!('educationImportance' in value) || value['educationImportance'] === undefined)
        return false;
    if (!('hardSkillsImportance' in value) || value['hardSkillsImportance'] === undefined)
        return false;
    if (!('softSkillsImportance' in value) || value['softSkillsImportance'] === undefined)
        return false;
    if (!('personalityImportance' in value) || value['personalityImportance'] === undefined)
        return false;
    return true;
}
export function MatchingConfigurationFromJSON(json) {
    return MatchingConfigurationFromJSONTyped(json, false);
}
export function MatchingConfigurationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'workExperienceImportance': FeatureImportanceFromJSON(json['workExperienceImportance']),
        'educationImportance': FeatureImportanceFromJSON(json['educationImportance']),
        'hardSkillsImportance': FeatureImportanceFromJSON(json['hardSkillsImportance']),
        'softSkillsImportance': FeatureImportanceFromJSON(json['softSkillsImportance']),
        'personalityImportance': FeatureImportanceFromJSON(json['personalityImportance']),
    };
}
export function MatchingConfigurationToJSON(json) {
    return MatchingConfigurationToJSONTyped(json, false);
}
export function MatchingConfigurationToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'workExperienceImportance': FeatureImportanceToJSON(value['workExperienceImportance']),
        'educationImportance': FeatureImportanceToJSON(value['educationImportance']),
        'hardSkillsImportance': FeatureImportanceToJSON(value['hardSkillsImportance']),
        'softSkillsImportance': FeatureImportanceToJSON(value['softSkillsImportance']),
        'personalityImportance': FeatureImportanceToJSON(value['personalityImportance']),
    };
}
